import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";

const Container = styled.div`
  background-color: var(--primary-100);
  width: 100%;
  max-width: 100vw;
  height: var(--navbar-mini);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled.header`
  height: 100%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    max-width: var(--max-width-container);
    padding: 0;
    width: 100%;
  }
`;
const FlexDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--bg-100);
`;
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const CustomLink = styled.div`
  color: var(--bg-100);
  font-size: var(--font-size-small);
  @media (min-width: 768px) {
    font-size: var(--font-size-base);
  }
`;

const TruckSVG = styled.svg`
  width: 20px;
  height: 20px;
  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

const HeaderDelivery = ({ isOpen, setIsOpen }) => {
  const { t, i18n } = useTranslation();
  const [countdown, setCountdown] = useState("");
  const [announcment, setAnnouncment] = useState("");
  const [tail, setTail] = useState("");

  const holidays = [
    "1 Jan",
    "2 Jan",
    "3 Jan",
    "4 Jan",
    "5 Jan",
    "6 Jan",
    "7 Jan",
  ];

  const getNextShipmentDate = (date) => {
    let nextDate = moment(date, "D MMM").add(1, "day");
    while (
      nextDate.day() === 6 ||
      nextDate.day() === 0 ||
      isHoliday(nextDate.format("D MMM"))
    ) {
      nextDate.add(1, "day");
    }
    return nextDate.format("ddd, D MMM");
  };

  const isHoliday = (today) => holidays.includes(today);
  const isWeekend = (day) => day === 0 || day === 6;
  const isFridayAfter15 = (day, hour) => day === 5 && hour >= 15;

  const updateAnnouncement = (
    setAnnouncment,
    setCountdown,
    setTail,
    message,
    date
  ) => {
    setAnnouncment(t(message));
    setCountdown(date);
    setTail("");
  };

  const getPostHolidayShipmentDate = (lastHoliday) => {
    return getNextShipmentDate(lastHoliday);
  };

  useEffect(() => {
    const now = moment();
    const today = now.format("D MMM");

    if (isHoliday(today)) {
      updateAnnouncement(
        setAnnouncment,
        setCountdown,
        setTail,
        "HEADER.ANNOUNCEMENT_NEXT_SHIPMENT",
        getPostHolidayShipmentDate(today)
      );
      return;
    }

    const targetTime = moment().endOf("day").hour(14).minute(30).second(0);
    setAnnouncment(t("HEADER.ANNOUNCEMENT_SHIPMENT_TOMORROW"));
    setTail(t("HEADER.ANNOUNCEMENT_REMAINING"));

    const timer = setInterval(() => {
      const duration = moment.duration(targetTime.diff(moment()));

      if (duration.asSeconds() <= 0) {
        clearInterval(timer);
        updateAnnouncement(
          setAnnouncment,
          setCountdown,
          setTail,
          "HEADER.ANNOUNCEMENT_NEXT_SHIPMENT",
          getNextShipmentDate(today)
        );
        return;
      }

      setCountdown(
        `${duration.hours()}h ${duration.minutes()}min ${duration.seconds()}sec`
      );

      if (isWeekend(now.day())) {
        updateAnnouncement(
          setAnnouncment,
          setCountdown,
          setTail,
          "HEADER.ANNOUNCEMENT_NEXT_SHIPMENT",
          getNextShipmentDate(today)
        );
        return;
      }

      if (isFridayAfter15(now.day(), now.hour())) {
        updateAnnouncement(
          setAnnouncment,
          setCountdown,
          setTail,
          "HEADER.ANNOUNCEMENT_NEXT_SHIPMENT",
          getNextShipmentDate(today)
        );
        return;
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [i18n.language]);

  useEffect(() => {
    // Provera da li je već sakriveno u tekućoj sesiji
    const isHidden = sessionStorage.getItem("headerDeliveryHidden");
    if (isHidden === "true") {
      setIsOpen(false);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Postavljanje u sessionStorage da se ne prikazuje ponovo
    sessionStorage.setItem("headerDeliveryHidden", "true");
  };

  if (!isOpen) {
    return null; // Ne prikazuje ništa ako je sakriveno
  }

  return (
    <Container>
      <Wrapper>
        <FlexDiv>
          <IconContainer>
            <TruckSVG
              version="1.1"
              id="_x32_"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              fill="var(--bg-100)"
            >
              <g>
                <path
                  class="st0"
                  d="M311.069,130.515c-0.963-5.641-5.851-9.768-11.578-9.768H35.43c-7.61,0-13.772,6.169-13.772,13.765
		c0,7.61,6.162,13.772,13.772,13.772h64.263c7.61,0,13.772,6.17,13.772,13.773c0,7.603-6.162,13.772-13.772,13.772H13.772
		C6.169,175.829,0,181.998,0,189.601c0,7.603,6.169,13.764,13.772,13.764h117.114c6.72,0,12.172,5.46,12.172,12.18
		c0,6.72-5.452,12.172-12.172,12.172H68.665c-7.61,0-13.772,6.17-13.772,13.773c0,7.602,6.162,13.772,13.772,13.772h45.857
		c6.726,0,12.179,5.452,12.179,12.172c0,6.719-5.453,12.172-12.179,12.172H51.215c-7.61,0-13.772,6.169-13.772,13.772
		c0,7.603,6.162,13.772,13.772,13.772h87.014l5.488,31.042h31.52c-1.854,4.504-2.911,9.421-2.911,14.598
		c0,21.245,17.218,38.464,38.464,38.464c21.237,0,38.456-17.219,38.456-38.464c0-5.177-1.057-10.094-2.911-14.598h100.04
		L311.069,130.515z M227.342,352.789c0,9.146-7.407,16.553-16.553,16.553c-9.152,0-16.56-7.407-16.56-16.553
		c0-6.364,3.627-11.824,8.892-14.598h15.329C223.714,340.965,227.342,346.424,227.342,352.789z"
                />
                <path
                  class="st0"
                  d="M511.598,314.072l-15.799-77.941l-57.689-88.759H333.074l32.534,190.819h38.42
		c-1.846,4.504-2.904,9.421-2.904,14.598c0,21.245,17.219,38.464,38.456,38.464c21.246,0,38.464-17.219,38.464-38.464
		c0-5.177-1.057-10.094-2.91-14.598h16.741c6.039,0,11.759-2.708,15.582-7.386C511.273,326.136,512.8,319.988,511.598,314.072z
		 M392.529,182.882h26.314l34.162,52.547h-51.512L392.529,182.882z M456.14,352.789c0,9.146-7.407,16.553-16.56,16.553
		c-9.138,0-16.552-7.407-16.552-16.553c0-6.364,3.635-11.824,8.892-14.598h15.329C452.513,340.965,456.14,346.424,456.14,352.789z"
                />
              </g>
            </TruckSVG>
            <CustomLink>
              {announcment}{" "}
              <span style={{ color: "var(--accent-200)" }}>{countdown}</span>{" "}
              {tail}{" "}
            </CustomLink>
          </IconContainer>
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            onClick={handleClose}
          >
            <path
              fill="var(--bg-100)"
              d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
            />
          </svg>
        </FlexDiv>
      </Wrapper>
    </Container>
  );
};

export default HeaderDelivery;
